// TODO [P3] Need refactoring all usages for this and move here thumbnailUrl
export default () => {
    const {$conf} = useNuxtApp()
    const {origin} = useRequestURL()
    const srcHost = (src: string) => ($conf.public.routerBase ? $conf.public.routerBase.slice(0, -1) + src : src)
    const fullUrl = (url: string) => origin + srcHost(url)
    return {srcHost, fullUrl}
}
